export const RECAPTCHA_SITEKEY = '6LfxOHsUAAAAAB4qPNAO2tq6WfdrD_Io8SDApIuD';
